var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, TemplateRef } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { TranslateParser } from '@ngx-translate/core';
import { AbstractDwFormPickComponent } from './abstract-form-picker.component';
import { DwDatePickerComponent } from 'ng-quicksilver';
import { toBoolean } from '../../../utils/convert';
import { DatePipe } from '@angular/common';
import { FxUserInfoService } from 'app/implementation/auth/fx-auth/fx-user-info.service';
var DwFormDatePickerComponent = /** @class */ (function (_super) {
    __extends(DwFormDatePickerComponent, _super);
    function DwFormDatePickerComponent(_fg, _ts, datePipe, userinfoService) {
        var _this = _super.call(this, _fg, _ts) || this;
        _this._fg = _fg;
        _this._ts = _ts;
        _this.datePipe = datePipe;
        _this.userinfoService = userinfoService;
        _this.dwShowToday = true;
        _this.dwOnOk = new EventEmitter();
        return _this;
        // this._dwFormat = this.userinfoService.getEntParamById('c_E031');
    }
    Object.defineProperty(DwFormDatePickerComponent.prototype, "dwShowTime", {
        get: function () { return this._showTime; },
        set: function (value) {
            this._showTime = typeof value === 'object' ? value : toBoolean(value);
            this._dwFormat = this._showTime ? this.userinfoService.getEntParamById('c_E031') + ' HH:mm:ss' : this.userinfoService.getEntParamById('c_E031');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DwFormDatePickerComponent.prototype, "dwOpen", {
        get: function () {
            return this.dwDatePicker ? this.dwDatePicker.dwOpen : false;
        },
        set: function (value) {
            if (this.dwDatePicker) {
                this.dwDatePicker.dwOpen = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    DwFormDatePickerComponent.prototype.afterContentInit = function () {
        if (this._open !== undefined) {
            this.dwDatePicker.dwOpen = this._open;
        }
    };
    DwFormDatePickerComponent.prototype.change = function (event) {
        this.onChange(event);
        this._dwFormat = this._showTime ? this.userinfoService.getEntParamById('c_E031') + ' HH:mm:ss' : this.userinfoService.getEntParamById('c_E031');
        this.dwValue = this.datePipe.transform(this.dwValue, this._dwFormat);
    };
    DwFormDatePickerComponent.prototype.onInit = function () {
    };
    return DwFormDatePickerComponent;
}(AbstractDwFormPickComponent));
export { DwFormDatePickerComponent };
